import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TestAuth } from '../../services/TestAuth';

@Component({
  selector: 'test-login',
  templateUrl: './TestLoginCmp.html',
  styleUrls: ['./TestLoginCmp.css'],
})
export class TestLoginCmp implements OnInit {
  username: string = '';
  password: string = '';
  errorMessage: string = '';
  showError: boolean = false;

  constructor(private testAuth: TestAuth, private router: Router) {}

  ngOnInit() {
    if (!this.testAuth.hasCrmSession()) {
      this.router.navigate(['/login']);
      return;
    }
    if (this.testAuth.isAuthenticated()) {
      this.router.navigate(['/test/events']);
    }
  }

  onSubmit() {
    this.showError = false;
    this.errorMessage = '';

    if (!this.username || !this.password) {
      this.showError = true;
      this.errorMessage = 'Both username and password are required.';
      return;
    }

    if (this.testAuth.login(this.username, this.password)) {
      this.router.navigate(['/test/events']);
    } else {
      this.showError = true;
      this.errorMessage = 'Invalid username or password.';
    }
  }

  onInputChange() {
    if (this.showError) {
      this.showError = false;
      this.errorMessage = '';
    }
  }
}